// extracted by mini-css-extract-plugin
export default {"confirmModal":"TlqTKU2j","heading":"yAXYUzX9","controls":"sBLA_lp5","textField":"zevoqiTd"};